import { EdgeSystemState } from "./system";

export enum SignalREvents {
    SYSTEM_STATE_UPDATED = 'SystemStateUpdated'
};

export interface SignalREventsMessageType {
    [SignalREvents.SYSTEM_STATE_UPDATED]: EdgeSystemState;
};